"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _debounce = require("debounce");

var _debounce2 = _interopRequireDefault(_debounce);

var _Loader = require("./Loader.js");

var _Loader2 = _interopRequireDefault(_Loader);

var _ramda = require("ramda");

var _BlurredLoader = require("../BlurredLoader");

var _BlurredLoader2 = _interopRequireDefault(_BlurredLoader);

var _Video = require("../Video");

var _Video2 = _interopRequireDefault(_Video);

var _CaretLeft = require("@vtex/styleguide/lib/icon/CaretLeft");

var _CaretLeft2 = _interopRequireDefault(_CaretLeft);

var _CaretRight = require("@vtex/styleguide/lib/icon/CaretRight");

var _CaretRight2 = _interopRequireDefault(_CaretRight);

var _noimage = require("./noimage.svg");

var _noimage2 = _interopRequireDefault(_noimage);

require("./global.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Swiper = window.navigator ? require('react-id-swiper')["default"] : null;
var initialState = {
  Swiper: null,
  loaded: [],
  thumbSwiper: null,
  gallerySwiper: null,
  thumbUrl: [],
  alt: [],
  thumbsLoaded: false,
  activeIndex: 0,
  failedImageIndexes: []
};
var placeholderSlide = {
  alt: 'Failed image',
  bestUrlIndex: 0,
  thumbUrl: _noimage2["default"],
  type: 'image',
  urls: [_noimage2["default"]]
};

var Carousel = /*#__PURE__*/function (_Component) {
  _inherits(Carousel, _Component);

  function Carousel(props) {
    var _this2;

    _classCallCheck(this, Carousel);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Carousel).call(this, props));

    _defineProperty(_assertThisInitialized(_this2), "debouncedRebuildOnUpdate", (0, _debounce2["default"])(function () {
      _this2.state.thumbSwiper && _this2.state.thumbSwiper.update();
    }, 500));

    _defineProperty(_assertThisInitialized(_this2), "getThumb", function (_ref) {
      var thumbUrl = _ref.thumbUrl,
          index = _ref.index;
      if (!window.navigator) return; // Image object doesn't exist when it's being rendered in the server side

      var image = new Image();

      image.onload = function () {
        _this2.incrementThumbsLoaded();
      };

      image.onerror = function () {
        _this2.incrementThumbsLoaded();

        _this2.setState({
          failedImageIndexes: _this2.state.failedImageIndexes.concat(index)
        });
      };

      image.src = thumbUrl;
    });

    _defineProperty(_assertThisInitialized(_this2), "linkThumb", function () {
      var _this = _assertThisInitialized(_this2);

      return function () {
        this.visibleSlidesIndexes || (this.visibleSlidesIndexes = []); // Swiper bug fix

        _this.rebuildGalleryOnUpdate = true;

        _this.setState({
          thumbSwiper: this
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this2), "linkGallery", function () {
      var _this = _assertThisInitialized(_this2);

      return function () {
        _this.setState({
          gallerySwiper: this
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this2), "onSlideChange", function () {
      var _this = _assertThisInitialized(_this2);

      return function () {
        var activeIndex = this.activeIndex;

        _this.setState({
          activeIndex: activeIndex
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this2), "setVideoThumb", function (i) {
      return function (url, title) {
        var thumbUrl = _objectSpread({}, _this2.state.thumbUrl);

        var alt = _objectSpread({}, _this2.state.alt);

        thumbUrl[i] = url;
        alt[i] = title;

        _this2.setState({
          thumbUrl: thumbUrl,
          alt: alt
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this2), "onImageLoad", function (i) {
      return function () {
        var loaded = _objectSpread({}, _this2.state.loaded);

        loaded[i] = true;

        _this2.setState({
          loaded: loaded
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this2), "renderSlide", function (slide, i) {
      var loaded = _this2.state.loaded;

      if (_this2.state.failedImageIndexes.includes(i)) {
        slide = placeholderSlide;
      }

      switch (slide.type) {
        case 'image':
          return _react2["default"].createElement("div", {
            className: "w-100 ".concat(loaded[i] ? 'swiper-zoom-container' : 'overflow-hidden')
          }, _react2["default"].createElement(_BlurredLoader2["default"], {
            loaderType: "SPINNER",
            loaderUrl: slide.thumbUrl,
            realUrls: slide.urls,
            bestUrlIndex: slide.bestUrlIndex,
            alt: slide.alt,
            onload: _this2.onImageLoad(i)
          }));

        case 'video':
          try {
            return _react2["default"].createElement(_Video2["default"], {
              url: slide.src,
              setThumb: _this2.setVideoThumb(i),
              playing: i === _this2.state.activeIndex,
              id: i,
              apiKey: slide.apiKey
            });
          } catch (err) {
            console.error("Error while loading ".concat(slide.src));
            return null;
          }

        default:
          return null;
      }
    });

    _this2.CaretPrev = props.CaretPrev || _CaretLeft2["default"];
    _this2.CaretNext = props.CaretNext || _CaretRight2["default"];
    _this2.state = initialState;

    _this2.setInitialVariablesState();

    return _this2;
  }

  _createClass(Carousel, [{
    key: "setInitialVariablesState",
    value: function setInitialVariablesState() {
      var _this3 = this;

      var slides = this.props.slides;
      this.isVideo = [];
      this.rebuildGalleryOnUpdate = false;
      this.thumbLoadCount = 0;

      if (slides) {
        var thumbPromises = slides.map(function (slide, i) {
          if (slide.type === 'video') {
            try {
              _this3.isVideo[i] = true;

              var thumbUrl = _Video2["default"].getThumbUrl(slide.src, slide.thumbWidth, slide.apiKey);

              return thumbUrl.then(function (url) {
                return {
                  thumbUrl: url,
                  index: i
                };
              })["catch"](function () {
                return Promise.reject(i);
              });
            } catch (error) {
              return Promise.reject(i);
            }
          }

          return Promise.resolve({
            thumbUrl: slide.thumbUrl,
            index: i
          });
        });
        thumbPromises.forEach(function (promise) {
          promise.then(_this3.getThumb)["catch"](function (index) {
            _this3.incrementThumbsLoaded();

            _this3.setState({
              failedImageIndexes: _this3.state.failedImageIndexes.concat(index)
            });
          });
        });
      }
    }
  }, {
    key: "incrementThumbsLoaded",
    value: function incrementThumbsLoaded() {
      this.thumbLoadCount++;

      if (this.thumbLoadCount === this.props.slides.length) {
        this.setState({
          thumbsLoaded: true
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.debouncedRebuildOnUpdate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedRebuildOnUpdate);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this4 = this;

      var _this$state = this.state,
          gallerySwiper = _this$state.gallerySwiper,
          loaded = _this$state.loaded,
          activeIndex = _this$state.activeIndex;
      var isVideo = this.isVideo;

      if (prevProps.slides !== this.props.slides) {
        this.setState(initialState, function () {
          return _this4.setInitialVariablesState();
        });
        return;
      }

      var paginationElement = (0, _ramda.path)(['pagination', 'el'], gallerySwiper);
      if (paginationElement) paginationElement.hidden = isVideo[activeIndex];
      var gallerySwiperZoom = (0, _ramda.path)(['zoom'], gallerySwiper);

      if (gallerySwiperZoom) {
        loaded[activeIndex] ? gallerySwiperZoom.enable() : gallerySwiperZoom.disable();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$state2 = this.state,
          thumbSwiper = _this$state2.thumbSwiper,
          thumbsLoaded = _this$state2.thumbsLoaded;
      var rebuildGalleryOnUpdate = this.rebuildGalleryOnUpdate;
      var slides = this.props.slides ? this.props.slides.map(function (slide) {
        return _objectSpread({}, slide);
      }) : [];

      if (!thumbsLoaded || Swiper == null) {
        return _react2["default"].createElement(_Loader2["default"], {
          slidesAmount: slides ? slides.length : 0
        });
      }

      var caretClassName = 'pv7 absolute top-50 translate--50y z-2 pointer c-action-primary';
      var galleryParams = {
        containerClass: 'swiper-container',
        pagination: slides.length > 1 ? {
          el: '.swiper-pagination',
          clickable: true,
          bulletActiveClass: 'c-action-primary swiper-pagination-bullet-active'
        } : {},
        navigation: slides.length > 1 ? {
          prevEl: '.swiper-caret-prev',
          nextEl: '.swiper-caret-next',
          disabledClass: 'c-disabled cursor-default'
        } : {},
        thumbs: {
          swiper: thumbSwiper
        },
        zoom: {
          maxRatio: 2
        },
        rebuildOnUpdate: rebuildGalleryOnUpdate,
        resistanceRatio: slides.length > 1 ? 0.85 : 0,
        renderNextButton: function renderNextButton() {
          return _react2["default"].createElement("span", {
            className: "swiper-caret-next pl7 right-1 ".concat(caretClassName)
          }, _react2["default"].createElement(_this5.CaretNext, null));
        },
        renderPrevButton: function renderPrevButton() {
          return _react2["default"].createElement("span", {
            className: "swiper-caret-prev pr7 left-1 ".concat(caretClassName)
          }, _react2["default"].createElement(_this5.CaretPrev, null));
        },
        on: {
          init: this.linkGallery(),
          slideChange: this.onSlideChange()
        }
      };
      this.rebuildGalleryOnUpdate = false;
      var thumbnailParams = {
        observer: true,
        containerClass: 'swiper-container h-100',
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        freeMode: true,
        direction: 'vertical',
        slidesPerView: 'auto',
        touchRatio: 0.4,
        mousewheel: true,
        preloadImages: true,
        on: {
          init: this.linkThumb()
        },
        shouldSwiperUpdate: true
      };
      return _react2["default"].createElement("div", {
        className: 'w-100 relative overflow-hidden'
      }, _react2["default"].createElement("div", {
        className: "w-20 gallery-thumbs bottom-0 top-0 left-0 absolute pr5 dn\n          ".concat(slides.length > 1 ? 'db-ns' : '')
      }, _react2["default"].createElement(Swiper, thumbnailParams, slides.map(function (slide, i) {
        if (_this5.state.failedImageIndexes.includes(i)) {
          slide.thumbUrl = placeholderSlide.thumbUrl;
        }

        return _react2["default"].createElement("div", {
          key: i,
          className: "swiper-slide w-100 h-auto mb5"
        }, _react2["default"].createElement("img", {
          className: "w-100 h-auto db",
          alt: slide.alt ? _this5.state.alt[i] : '',
          src: slide.thumbUrl || _this5.state.thumbUrl[i]
        }), _react2["default"].createElement("div", {
          className: "absolute absolute--fill b--solid b--muted-2 bw1 thumb-border"
        }));
      }))), _react2["default"].createElement("div", {
        className: "w-100 ".concat(slides.length > 1 ? 'w-80-ns ml-20-ns' : '', " border-box gallery-cursor")
      }, _react2["default"].createElement(Swiper, galleryParams, slides.map(function (slide, i) {
        return _react2["default"].createElement("div", {
          key: i,
          className: "swiper-slide center-all"
        }, _this5.renderSlide(slide, i));
      }))));
    }
  }]);

  return Carousel;
}(_react.Component);

Carousel.propTypes = {
  CaretPrev: _propTypes2["default"].node,
  CaretNext: _propTypes2["default"].node,
  slides: _propTypes2["default"].arrayOf(_propTypes2["default"].oneOfType([_propTypes2["default"].shape({
    type: _propTypes2["default"].string,

    /** Props for type == 'image' */
    urls: _propTypes2["default"].arrayOf(_propTypes2["default"].string),
    alt: _propTypes2["default"].string,
    thumbUrl: _propTypes2["default"].string,
    bestUrlIndex: _propTypes2["default"].number
  }), _propTypes2["default"].shape({
    type: _propTypes2["default"].string,

    /** Props for type 'video' */
    src: _propTypes2["default"].string,
    thumbWidth: _propTypes2["default"].number
  })]))
};
exports["default"] = Carousel;